import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';
require('dayjs/locale/en');

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(relativeTime);

export const formatDate = (date?: string) => (date ? dayjs(date).format('DD/MM/YYYY') : '-');

export const parseDate = (date: string) => dayjs(date, 'DD/MM/YYYY', true).utc(true);

export const uiToISO = (date: string) =>
  dayjs(date, 'DD/MM/YYYY', 'en').utc(true).format('YYYY-MM-DD');

export const validateUiDate = (date?: string | null): boolean =>
  Boolean(date && parseDate(date).isValid());

export const isMaxYearsFromNow = (date: string | Dayjs, years: number): boolean =>
  dayjs().diff(date, 'year') <= years;

export const isInThePast = (date: string): boolean => dayjs().diff(parseDate(date), 'day') > 0;

export const formatDateTime = (date?: string) =>
  date ? dayjs(date).format('DD/MM/YYYY h:mma') : '-';
